import { forwardRef } from 'react';

const Input = forwardRef(({ 
  type = 'text',
  placeholder,
  value,
  onChange,
  disabled = false,
  className = '',
  search = false,
  ...props 
}, ref) => {
  const searchClass = search ? 'input-search' : '';
  const classes = ['input', searchClass, className].filter(Boolean).join(' ');

  return (
    <input
      ref={ref}
      type={type}
      className={classes}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
